import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 13,
				y: 5,
				width: 38,
				height: 48,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("path", { d: "M21 18h22a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1V19a1 1 0 0 1 1-1z" }),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(19.294 39.83)",
				children: [/* @__PURE__ */ _jsx("circle", {
					cx: 3.706,
					cy: 3.169,
					r: 3
				}), /* @__PURE__ */ _jsx("circle", {
					cx: 21.706,
					cy: 3.169,
					r: 3
				})]
			}),
			/* @__PURE__ */ _jsx("path", { d: "M51 12h5v5m-43-5H8v5m35 36v6m-23-6v6m0-47h24" })
		]
	})
});
export default SvgBusinline;
